import * as bootstrap from 'bootstrap';

export function Copy(s: string, $tooltipTarget?: HTMLElement) {
    void navigator.clipboard.writeText(s).then(() => {
        if ($tooltipTarget) {
            const t = new bootstrap.Tooltip($tooltipTarget, {
                title: 'Copied!',
                trigger: 'manual',
            });
            t.show();
            setTimeout(() => t.dispose(), 2000);
        }
    }).catch(err => {
        console.warn('Copy to clipboard failed.', err);
    });
}